import {ApiClient} from '@/api/api.client';

export const api = new ApiClient({
    baseURL: process.env.VUE_APP_API_URL
});

